
export default {
  props: {
    configurationOffers: Array
  },
  data() {
    return {
      isVisible: {
        complectation: false
      },
      complectation_select_title: 'Выберите комплектацию'
    }
  },
  computed: {
    currentCarId() {
      return this.$route.params.car;
    },
    complectationsList() {
      if (!this.configurationOffers) return [];
      
      const complectations = [];
      this.configurationOffers.forEach(config => {
        config.complectations.forEach(comp => {
          complectations.push({
            id: comp.offer_external_id,
            label: `${comp.name} - ${config.name}`,
            offer_external_id: comp.offer_external_id,
            configName: config.name,
            compName: comp.name
          });
        });
      });
      return complectations;
    },
    currentComplectation() {
      return this.complectationsList.find(
        comp => String(comp.offer_external_id) === String(this.currentCarId)
      );
    }
  },
  watch: {
    currentComplectation: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.complectation_select_title = newVal.label;
        } else {
          this.complectation_select_title = 'Выберите комплектацию';
        }
      }
    }
  },
  methods: {
    checkComplectation(complectationItem) {
      this.isVisible.complectation = false;
      
      if (String(complectationItem.offer_external_id) === String(this.currentCarId)) return;
      
      this.$router.push({
        path: `/cars/${this.$route.params.mark}/${this.$route.params.model}/${complectationItem.offer_external_id}`
      });
    },
    closeComplectationDropdown() {
      this.isVisible.complectation = false;
    }
  },
  mounted() {
    document.addEventListener('click', this.closeComplectationDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeComplectationDropdown);
  }
}
